// extracted by mini-css-extract-plugin
module.exports = {"capsuleTable":"CapsuleTable_capsuleTable__3otyN"};